import { getOperation } from "utils/api";
import {
  createOptionsCacheHook,
  resolveHasMoreOptions,
} from "./globalOptionsCache";

const PAGE_SIZE = 500;
const CACHE_NAMESPACE = "agent-options";

const buildAgentOption = (agent) => {
  const email = agent?.email || "";
  const isoAgentId = agent?.isoAgentId || "";
  const firstName = agent?.firstName || "";
  const lastName = agent?.lastName || "";
  const fullName = [firstName, lastName].join(" ");

  if (!email) return null;

  return {
    key: email,
    title: [isoAgentId, fullName, email].join(" - "),
    value: email,
    id: agent?.isoAgentId,
    email,
  };
};

const fetchAgentOptionsFromApi = async (keyword) => {
  try {
    const requestParams = {
      page: 0,
      size: PAGE_SIZE,
      ...(keyword ? { keyword } : {}),
    };

    const apiResponse = await getOperation("/agent/options", {
      ...requestParams,
    });

    const responseBody = apiResponse?.data;
    if (!responseBody || responseBody.responseCode !== "0000") {
      return { options: [], hasMoreOptions: false };
    }

    const options = responseBody.data?.map(buildAgentOption).filter(Boolean) || [];

    return {
      options,
      hasMoreOptions: resolveHasMoreOptions(
        responseBody?.total,
        options.length,
        PAGE_SIZE,
      ),
    };
  } catch (error) {
    return { options: [], hasMoreOptions: false };
  }
};

export const useAgentOptionsCache = createOptionsCacheHook({
  namespace: CACHE_NAMESPACE,
  buildCacheKey: (keyword = "") => JSON.stringify({ keyword }),
  fetcher: (keyword = "") => fetchAgentOptionsFromApi(keyword),
  fetchProperty: "fetchAgentOptions",
  invalidateProperty: "invalidateAgentOptionsCache",
});
